import React from "react";
import { Container, Row, Col, Table } from "react-bootstrap";
import PaginationLink from "../Components/PaginationLink";
function VerfiedContracts() {
  return (
    <>
      <div className="main-inner">
        <div className="container-fluid">
          <Row>
            <Container>
              <Row>
                <Col xl="12" md="12">
                  <h2>
                    Contracts <span>With verified source codes only</span>
                  </h2>
                </Col>
                <Col xl="12" md="12">
                  <div className="table-container">
                    <div className="table-inner-container">
                      <p className="heading-p">A total of 8 found</p>
                      <Table hover>
                        <thead>
                          <tr>
                            <th>Address</th>
                            <th>Contract Name</th>
                            <th>Compiler</th>
                            <th>version</th>
                            <th>Balance</th>
                            <th>Txns</th>
                            <th>Setting</th>
                            <th>Verified</th>
                            <th>Audited</th>
                            <th>License</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <h6>
                                <i className="fa fa-check"></i>{" "}
                                0x2D97F4b69298C...76B3D
                              </h6>
                            </td>

                            <td></td>
                            <td>
                              <p>Solidity</p>
                            </td>
                            <td>
                              <p>v0.8.0+commit.c7dfd78e</p>
                            </td>
                            <td>
                              <p>0</p>
                            </td>
                            <td>
                              <p>0</p>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>
                              <p>No License (None)</p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <h6>
                                <i className="fa fa-check"></i>{" "}
                                0x2D97F4b69298C...76B3D
                              </h6>
                            </td>

                            <td></td>
                            <td>
                              <p>Solidity</p>
                            </td>
                            <td>
                              <p>v0.8.0+commit.c7dfd78e</p>
                            </td>
                            <td>
                              <p>0</p>
                            </td>
                            <td>
                              <p>0</p>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>
                              <p>No License (None)</p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <h6>
                                <i className="fa fa-check"></i>{" "}
                                0x2D97F4b69298C...76B3D
                              </h6>
                            </td>

                            <td></td>
                            <td>
                              <p>Solidity</p>
                            </td>
                            <td>
                              <p>v0.8.0+commit.c7dfd78e</p>
                            </td>
                            <td>
                              <p>0</p>
                            </td>
                            <td>
                              <p>0</p>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>
                              <p>No License (None)</p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <h6>
                                <i className="fa fa-check"></i>{" "}
                                0x2D97F4b69298C...76B3D
                              </h6>
                            </td>

                            <td></td>
                            <td>
                              <p>Solidity</p>
                            </td>
                            <td>
                              <p>v0.8.0+commit.c7dfd78e</p>
                            </td>
                            <td>
                              <p>0</p>
                            </td>
                            <td>
                              <p>0</p>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>
                              <p>No License (None)</p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <h6>
                                <i className="fa fa-check"></i>{" "}
                                0x2D97F4b69298C...76B3D
                              </h6>
                            </td>

                            <td></td>
                            <td>
                              <p>Solidity</p>
                            </td>
                            <td>
                              <p>v0.8.0+commit.c7dfd78e</p>
                            </td>
                            <td>
                              <p>0</p>
                            </td>
                            <td>
                              <p>0</p>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>
                              <p>No License (None)</p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <h6>
                                <i className="fa fa-check"></i>{" "}
                                0x2D97F4b69298C...76B3D
                              </h6>
                            </td>

                            <td></td>
                            <td>
                              <p>Solidity</p>
                            </td>
                            <td>
                              <p>v0.8.0+commit.c7dfd78e</p>
                            </td>
                            <td>
                              <p>0</p>
                            </td>
                            <td>
                              <p>0</p>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>
                              <p>No License (None)</p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <h6>
                                <i className="fa fa-check"></i>{" "}
                                0x2D97F4b69298C...76B3D
                              </h6>
                            </td>

                            <td></td>
                            <td>
                              <p>Solidity</p>
                            </td>
                            <td>
                              <p>v0.8.0+commit.c7dfd78e</p>
                            </td>
                            <td>
                              <p>0</p>
                            </td>
                            <td>
                              <p>0</p>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>
                              <p>No License (None)</p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <h6>
                                <i className="fa fa-check"></i>{" "}
                                0x2D97F4b69298C...76B3D
                              </h6>
                            </td>

                            <td></td>
                            <td>
                              <p>Solidity</p>
                            </td>
                            <td>
                              <p>v0.8.0+commit.c7dfd78e</p>
                            </td>
                            <td>
                              <p>0</p>
                            </td>
                            <td>
                              <p>0</p>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>
                              <p>No License (None)</p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <h6>
                                <i className="fa fa-check"></i>{" "}
                                0x2D97F4b69298C...76B3D
                              </h6>
                            </td>

                            <td></td>
                            <td>
                              <p>Solidity</p>
                            </td>
                            <td>
                              <p>v0.8.0+commit.c7dfd78e</p>
                            </td>
                            <td>
                              <p>0</p>
                            </td>
                            <td>
                              <p>0</p>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>
                              <p>No License (None)</p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <h6>
                                <i className="fa fa-check"></i>{" "}
                                0x2D97F4b69298C...76B3D
                              </h6>
                            </td>

                            <td></td>
                            <td>
                              <p>Solidity</p>
                            </td>
                            <td>
                              <p>v0.8.0+commit.c7dfd78e</p>
                            </td>
                            <td>
                              <p>0</p>
                            </td>
                            <td>
                              <p>0</p>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>
                              <p>No License (None)</p>
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                      <div className="pagination-container">
                        {/* <PaginationLink /> */}
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </Row>
        </div>
      </div>
    </>
  );
}
export default VerfiedContracts;
